import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
// import NavDropdown from "react-bootstrap/NavDropdown";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faChevronCircleDown,
  faEllipsisVertical,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const CNavBar = (props) => {
  let menuList = [];
  let buttonList = [];
  // let dropdownList = [];

  const brandText = props.brandText;
  const brandImg = props.brandImg;
  const IsOutline = props.IsOutline;

  const isbrandText = props.isbrandText === true ? true : false;
  const brandTextColor =
    props.brandTextColor === undefined ? "dark" : props.brandTextColor;
  const isMenu = props.isMenu === true ? true : false;
  // const isDropdown = props.isDropdown === true ? true : false;
  const isButton = props.isButton === true ? true : false;
  const navFixed = props.navFixed === undefined ? "" : props.navFixed;
  const btnClassDiv = props.btnClassDiv === undefined ? "" : props.btnClassDiv;

  const navBgColor =
    props.navBgColor === undefined ? "secondary" : props.navBgColor;
  const btnSize =
    props.btnSize === undefined ? "btn-md" : `btn-${props.btnSize}`;
  const btnFw =
    props.btnFontWeight === undefined ? "normal" : `fw-${props.btnFontWeight}`;
  const spaceBetweenItems =
    props.spaceBetweenItems === undefined ? 2 : `${props.spaceBetweenItems}`;
  const variant =
    IsOutline === true
      ? `btn-outline-${props.outlineVariant}`
      : `btn-${props.BtnVariant}`;
  const imgWidth = props.imgWidth === undefined ? "100%" : props.imgWidth;
  const imgHeight = props.imgHeight === undefined ? "30px" : props.imgHeight;
  const menuAlignment =
    props.menuAlignment === "center"
      ? "m-auto"
      : props.menuAlignment === "left"
      ? "me-auto"
      : props.menuAlignment === "right"
      ? "ms-auto"
      : "";
  const btnCustomStyle =
    props.btnCustomStyle === undefined ? {} : props.btnCustomStyle;
  const brandTextStyle =
    props.brandTextStyle === undefined ? {} : props.brandTextStyle;
  const btnClasses = props.btnClasses === undefined ? "" : props.btnClasses;
  const faIcon = props.faIcon === undefined ? "" : props.faIcon;
  const faTitle = props.faTitle === undefined ? "" : props.faTitle;
  const faClass = props.faClass === undefined ? "" : props.faClass;
  const faStyle = props.faStyle === undefined ? {} : props.faStyle;
  const brandPath = props.brandPath === undefined ? "" : props.brandPath;

  if (isMenu) {
    menuList = props.menuListArray;
  }
  if (isButton) {
    buttonList = props.buttonListArray;
  }
  // if (isDropdown) {
  //     dropdownList = props.dropdownListArray;
  // }

  return (
    <>
      <Navbar
        expand="md"
        bg={navBgColor}
        fixed={navFixed}
        id="sidenavAccordion"
      >
        <div className="container-fluid">
          <div className="me-auto">
            <button id="sidebarToggle" className="me-2 btn btn-transparent">
              <FontAwesomeIcon
                icon={faIcon}
                className={faClass}
                style={faStyle}
                title={faTitle}
              />
            </button>

            {isbrandText === true ? (
              <Link to={brandPath} style={{textDecoration:"none"}}>
              <Navbar.Brand
                className={`${brandTextColor}`}
                style={brandTextStyle}
              >
                {brandText}
              </Navbar.Brand>
              </Link>
            ) : (
              <Navbar.Brand>
                <img
                  src={brandImg}
                  width={imgWidth}
                  height={imgHeight}
                  className="d-inline-block align-top"
                  alt=""
                />
              </Navbar.Brand>
            )}
          </div>
          {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
          {/* <Navbar.Collapse id="responsive-navbar-nav"> */}
          <Nav className={`${menuAlignment}`}>
            {isMenu === true ? (
              <>
                {menuList.map((item, index) => (
                  <Nav.Link href={item} className={`ms-${spaceBetweenItems}`}>
                    {item}
                  </Nav.Link>
                ))}
              </>
            ) : (
              ""
            )}
            {/* {isDropdown === true ? (
                                <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
                                    <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                                    <NavDropdown.Item href="#action/3.2">
                                        Another action
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="#action/3.3">
                                        Something
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item href="#action/3.4">
                                        Separated link
                                    </NavDropdown.Item>
                                </NavDropdown>
                            ) : ""} */}
            {isButton === true ? (
              <>
                {buttonList.map((item) => (
                  <div className={btnClassDiv}>
                    <Button
                      className={`btn ${variant} ${btnSize} ${btnFw} ${btnClasses} ms-${spaceBetweenItems}`}
                      style={btnCustomStyle}
                      onClick={() => props.setAction()}
                    >
                      {item}
                    </Button>
                  </div>
                ))}
              </>
            ) : (
              ""
            )}
          </Nav>
          {/* </Navbar.Collapse> */}
        </div>
      </Navbar>
    </>
  );
};

export default CNavBar;
